<template>
  <BaseWrapper :loading="loading">
    <Datatable :columns="columns">
      <template v-slot:tbody="{ classes }">
        <Draggable tag="tbody" v-model="productCategories.data" @end="onChange">
          <tr v-for="productCategory in productCategories.data" :key="productCategory.id"
            :class="[classes.tr, 'bg-white border-b']">
            <td :class="[classes.td]">
              <div class="flex items-center gap-2">
                <button>
                  <Icon icon="heroicons:bars-3" />
                </button>
                {{ productCategory.attributes.name }}
              </div>
            </td>
          </tr>
        </Draggable>
      </template>
    </Datatable>
  </BaseWrapper>
</template>

<script>
import { requestMixin } from '../../../../mixins/request/request';
import Draggable from 'vuedraggable'

export default {
  mixins: [requestMixin],
  components: { Draggable },
  data() {
    return {
      loading: true,
      productCategories: {
        data: []
      },
    }
  },
  computed: {
    columns() {
      return [
        { id: 'name', name: 'Nama' }
      ]
    }
  },
  methods: {
    async loadProductCategories() {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/product-categories`, {
        params: {
          'sort': 'order'
        }
      })

      if (!err) {
        this.productCategories = res
      }

      this.loading = false
    },
    async onChange() {
      this.loading = true

      const orders = this.productCategories.data.map((productCategory, i) => ({
        id: productCategory.id,
        name: productCategory.attributes.name,
        order: i + 1
      }))

      await this.request(`/api/v1/product-categories/-actions/update-orders`, {
        method: 'post',
        data: { orders }
      })

      this.loading = false
    }
  },
  created() {
    this.loadProductCategories()
  }
}
</script>
